var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-form-checkbox',_vm._b({model:{value:(_vm.checked),callback:function ($$v) {_vm.checked=$$v},expression:"checked"}},'b-form-checkbox',_vm.$attrs,false),[_vm._v(" "+_vm._s(_vm.$t('confidentialSubtitles.label'))+" "),_c('small',{staticClass:"form-text",class:_vm.helpClass},[_vm._v(" "+_vm._s(_vm.$t('confidentialSubtitles.helpText'))+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }